import moment from 'moment';
import { PeopleHrUserServerSide } from './people-hr-user-server-side.model';

export class PeopleHrUser {
  id: number;
  userId: number;
  uniqueId: string;
  employeeId: string;
  managerId: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  startDate: string;
  department: string;
  position: string;
  officeLocation: string;
  created: Date;
  updated: Date;

  constructor(peopleHrUserServerSide: PeopleHrUserServerSide){
    this.id = peopleHrUserServerSide.id;
    this.userId = peopleHrUserServerSide.userId;
    this.uniqueId = peopleHrUserServerSide.uniqueId;
    this.employeeId = peopleHrUserServerSide.employeeId;
    this.managerId = peopleHrUserServerSide.managerId;
    this.firstName = peopleHrUserServerSide.firstName;
    this.lastName = peopleHrUserServerSide.lastName;
    this.dateOfBirth = peopleHrUserServerSide.dateOfBirth;
    this.startDate = peopleHrUserServerSide.startDate;
    this.department = peopleHrUserServerSide.department;
    this.position = peopleHrUserServerSide.position;
    this.officeLocation = peopleHrUserServerSide.officeLocation;
    this.created = moment.utc(peopleHrUserServerSide.created).toDate();
    this.updated = moment.utc(peopleHrUserServerSide.updated).toDate();
  }

}